@import "./shared/styles/breakpoints.css";

/* Column frame: the (admin-only) admin bar row, then the shell filling the rest. */
.frame {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
}

.shell {
  display: grid;
  grid-template-columns: 1fr;
  flex: 1;
  min-height: 0;
  overflow: hidden;
  position: relative;
}

.content {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-height: 0;
  min-width: 0;
}

@media (--md) {
  .shell {
    grid-template-columns: var(--p-sidenav-width-collapsed) 1fr;
  }

  .shell.pinned {
    grid-template-columns: auto 1fr;
  }

  .content {
    grid-column: 2;
  }
}
